// Shared, typed contract for fetchUser's tri-state authentication probe.
//
// CHOM incident 2026-06-10 — fetchUser returns one of three states and the
// useSherwoodUser hook decides whether to expel the session based on them.
// Without a shared type, a typo in the hook's string comparison would silently
// fall into the keep-session ("network") branch — failing OPEN, the exact wrong
// direction for an auth gate. This module is the single source of truth: the
// `AuthProbe` type makes the hook's comparisons compile-checked, and the
// `AUTH_PROBE` runtime constants let authService.js (plain JS) return the same
// literals without a typed import.
export type AuthProbe = 'ok' | 'unauthorized' | 'network';

export const AUTH_PROBE = {
    OK: 'ok',
    UNAUTHORIZED: 'unauthorized',
    NETWORK: 'network',
} as const;
